var iconLibraryIdManifest = {
  far: '21okjngl7FL',
  fas: '41YMl4fg6xL',
  fab: '31Qfulu3H7L'
};

export { iconLibraryIdManifest as i };
//# sourceMappingURL=iconLibraryIdManifest-WnPW8pRL-WnPW8pRL.js.map
